module.exports = __webpack_public_path__ + "img/logociadelamoda40.e3c099d3.png";